<template>
    <v-container grid-list-md>
        <v-layout id="experience_edit" row wrap>
            <v-flex xs12 sm6 class="flex_padding">
                <div class="custom_card">
                    <h3>Paramètres de l'expérience</h3>
                    <v-card ref="form" class="form_experience_parameters">
                        <v-card-text>
                            <v-text-field ref="name" v-model="name" :error-messages="errorMessages"
                                          label="Nom de l'expérience" placeholder="" required filled
                                          :rules="[rules.required, rules.counterName]" counter maxlength="50" />
                            <v-divider class="mt-4" />
                            <v-textarea ref="description" v-model="description" label="Description"
                                        placeholder="Courte description de l'expérience" filled
                                        :rules="[rules.counterDescription]" counter maxlength="300" />
                        </v-card-text>
                        <v-card-actions v-if="formHasChange">
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <v-btn class="custom_btn_position custom_btn_color_red" @click="cancelChange">
                                        <i class="fas fa-times fa-btn" />
                                        <span v-if="!isMobile">Annuler</span>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn class="custom_btn_position custom_btn_color_blue" :disabled="formHasErrors"
                                           @click="localPublishExperienceParameters">
                                        <i class="fa fa-check" />
                                        <span v-if="!isMobile">Valider</span>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-flex>
            <v-flex xs12 sm6 class="flex_padding">
                <div class="custom_card">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h3>Mettre en pause</h3>
                            <div class="custom_text_statement">
                                Status actuel: {{ !experience.frozen ? 'Activé' : 'Désactivé' }}
                            </div>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn class="custom_btn_position"
                                   :class="[experience.frozen ? 'custom_btn_color_blue' : 'custom_btn_color_red']"
                                   @click="modeFrozenExperience">
                                <i v-if="experience.frozen" class="fas fa-check fa-btn" />
                                <i v-if="!experience.frozen" class="fas fa-times fa-btn" />
                                <span>
                                    {{ experience.frozen ? 'Activer' : 'Désactiver' }} cette expérience
                                </span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'AugmentationsTabParameters',
        data: () => ({
            name: '',
            description: '',
            errorMessages: '',
            formHasErrors: false,
            rules: {
                required: value => !!value || 'Required.',
                counterName: value => (value.length <= 50) || 'Max 50 characters',
                counterDescription: value => (value.length <= 300) || 'Max 300 characters'
            }
        }),
        computed: {
            ...mapGetters('augmentations', ['experience']),
            ...mapGetters('app', ['isMobile']),
            form: function () {
                return { name: this.name, description: this.description };
            },
            formHasChange: function () {
                return this.name !== this.experience.name || this.description !== this.experience.description;
            }
        },
        watch: {
            name () {
                this.checkForm();
                this.errorMessages = '';
            },
            description () {
                this.checkForm();
                this.errorMessages = '';
            }
        },
        mounted () {
            this.initParameters();
            this.checkForm();
        },
        methods: {
            ...mapActions('augmentations', ['modeFrozenExperience', 'publishExperienceParameters']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            initParameters: function () {
                this.name = this.experience.name;
                this.description = this.experience.description;
            },
            cancelChange () {
                this.errorMessages = '';
                this.formHasErrors = false;
                this.initParameters();
            },
            checkForm: function () {
                this.formHasErrors = false;
                Object.keys(this.form).forEach(f => {
                    this.formHasErrors = this.formHasErrors || !this.$refs[f].validate(true);
                });
            },
            localPublishExperienceParameters: function () {
                this.publishExperienceParameters(this.form).then(() => {
                    this.$toasted.success('Mise à jour des paramètres de l\'expérience avec succés');
                }).catch((err) => {
                    this.$toasted.error('Une erreur est apparu : ' + err);
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .container {
        padding: 25px;
        max-width: 100% !important;
    }

    .flex_padding {
        padding: 10px !important;
    }

    #experience_edit .custom_card {
        background-color: #FFF;
        border-radius: 5px;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
        margin-bottom: 20px;
        padding: 15px 0 25px 0;
    }

    #experience_edit .custom_card h3 {
        font-size: 28px !important;
        color: #393E46;
        font-weight: 300;
        font-family: "Fira Sans", sans-serif;
        text-align: center;
        display: inline-block;
        hyphens: initial;
    }

    .custom_text {
        background-color: #f1f1f1;
        padding: 15px;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .custom_btn_position {
        width: calc(100% - 40px) !important;
        margin-left: 20px;
        margin-right: 20px;
        min-width: calc(100% - 40px) !important;
    }

    .custom_text_statement {
        margin-bottom: 10px;
    }

    .form_experience_parameters {
        width: 100%;
        box-shadow: unset;
        margin-top: 10px;
        border-top: rgba(0, 0, 0, 0.2) 1px solid;
    }

    .form_experience_parameters button {
        min-width: 100px;
        width: 100px;
    }

    .form_experience_parameters .v-card__actions {
        padding-bottom: 0;
    }
</style>
